/* $(document).ready(function () {
    previewThumbailFromUrl({
        selector: 'sample-img',
        fileName: 'sample Img',
        imageURL: 'http://img.tfd.com/wn/93/17E8B3-awful.png'
    });

    function previewThumbailFromUrl(opts) {
        var imgDropzone = Dropzone.forElement("#" + opts.selector);

        var mockFile = {
            name: opts.fileName,
            size: 32345,
            accepted: true,
            kind: 'image'
        };

        imgDropzone.emit("addedfile", mockFile);
        imgDropzone.files.push(mockFile);
        imgDropzone.createThumbnailFromUrl(mockFile, opts.imageURL, function () {
            imgDropzone.emit("complete", mockFile);
        }, "anonymous");
    }

}); */